import { getProductDetail } from "../../../../lib/admin";
import { Product } from "../../../../types";
import StoreReportDetails, { DetailBox, DetailFields, formatDetailDate } from "../shared/StoreReportDetails";
import { useReportDetail } from "../hooks/useReportDetail";

type Props =
    {
        storeId: number
        product: Product
    }

const formatPrice = (from: number | null | undefined, to: number | null | undefined) => {
    if (from === null || from === undefined) return "";
    if (to === null || to === undefined || from === to) return `${from}`;

    return `${from} - ${to}`;
};

export default function StoreReportProductDetails({ storeId, product }: Props) {
    const { detail, isLoading, error } = useReportDetail(
        () => getProductDetail(storeId, product.id),
        `${storeId}:${product.id}`,
        "Could not load the details of this product.",
    );

    return (
        <StoreReportDetails mirrorError={product.error} isLoading={isLoading} error={error}>
            {(showRaw) => detail && (
                <div className="product-details-grid">
                    <DetailBox title="In Shopify" source={detail.shopify} found={detail.shopify.found} error={detail.shopify.error} showRaw={showRaw}>
                        <DetailFields entries={[
                            ["Title", detail.shopify.title ?? ""],
                            ["Handle", detail.shopify.handle ?? ""],
                            ["Status", detail.shopify.status ?? ""],
                            ["Updated", formatDetailDate(detail.shopify.updatedAt)],
                        ]} />
                    </DetailBox>
                    <DetailBox title="On index" source={detail.index} found={detail.index.found} error={detail.index.error} showRaw={showRaw}>
                        <DetailFields entries={[
                            ["Title", detail.index.document?.title ?? ""],
                            ["Handle", detail.index.document?.handle ?? ""],
                            ["In stock", detail.index.document?.instock ?? ""],
                            ["Price", formatPrice(detail.index.document?.fromPrice, detail.index.document?.toPrice)],
                            ["Images", `${detail.index.document?.images?.length ?? 0}`],
                            ["Brand", detail.index.document?.brand?.title ?? ""],
                            ["Product range", detail.index.document?.product_range?.title ?? ""],
                            ["Categories", `${detail.index.document?.categories?.length ?? 0}`],
                        ]} />
                    </DetailBox>
                </div>
            )}
        </StoreReportDetails>
    );
}
